export default __webpack_public_path__ + "static/media/VO_CB11.71769c1d.gif";